// extracted by mini-css-extract-plugin
export default {"latest-item":"LatestConversations_latest-item__nDcNk","fixed-bottom-right":"LatestConversations_fixed-bottom-right__g17Nq"};